var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInstitution)?_c('PublicDashboardInstitution'):(_vm.showPlatformDashboard)?_c('PublicDashboardPlatform',{attrs:{"display-is":_vm.displayIs}}):_c('PublicDashboardPartner',{attrs:{"display-is":_vm.displayIs}})
}
var staticRenderFns = []

export { render, staticRenderFns }